import TextField, { TextFieldProps } from '@mui/material/TextField'
import { useTheme } from '@mui/material/styles'
import React from 'react'

const StyledTextField: React.FC<TextFieldProps> = (props) => {
  const theme = useTheme()

  return (
    <TextField
      {...props}
      FormHelperTextProps={{
        sx: {
          marginLeft: 0,
          textTransform: 'none',
          mt: theme.spacing(1.0),
        },
        ...props.FormHelperTextProps,
      }}
      sx={{
        width: theme.spacing(50),
        // when textfield is hovered
        '&:hover .MuiInputBase-root': {
          backgroundColor: theme.palette.action.hover,
        },
        // when textfield is focused
        '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
          borderColor: theme.palette.primary.main,
        },
        // when there is an error
        '& .MuiFormHelperText-root.Mui-error': {
          color: theme.palette.error.dark,
        },
        '& .MuiInputLabel-root.Mui-error': {
          color: theme.palette.error.dark,
        },
        '& .MuiInput-root.Mui-error': {
          color: theme.palette.error.dark,
        },
        '& .MuiOutlinedInput-root.Mui-error .MuiOutlinedInput-notchedOutline': {
          borderColor: theme.palette.error.dark,
        },
        '& .MuiOutlinedInput-root.Mui-focused.Mui-error .MuiOutlinedInput-notchedOutline': {
          borderColor: theme.palette.error.dark,
        },
        // when textfield is enabled and not focused and has no error
        '& .MuiOutlinedInput-root:not(.Mui-focused):not(.Mui-error):not(.Mui-disabled) input:not(:placeholder-shown) ~ .MuiOutlinedInput-notchedOutline':
          {
            borderColor: theme.palette.grey[500],
          },
        ...props.sx,
      }}
    />
  )
}

export default StyledTextField
